import type { IPatternType } from "@api/patterns";
import { generatePath } from "@routes/generatePath.ts";
import type { ID } from "@constants";

const patternListRoute = "/patterns/:type";
const patternCreateRoute = "/patterns/:type/create";
const patternViewRoute = "/patterns/:type/view/:id";
const patternUpdateRoute = "/patterns/:type/update/:id";

export const path = {
  list: {
    route: patternListRoute,
    link: (type: IPatternType) => generatePath(patternListRoute, { type }),
  },
  create: {
    route: patternCreateRoute,
    link: (type: IPatternType) => generatePath(patternCreateRoute, { type }),
  },
  view: {
    route: patternViewRoute,
    link: (type: IPatternType, id: ID) =>
      generatePath(patternViewRoute, { type, id }),
  },
  update: {
    route: patternUpdateRoute,
    link: (type: IPatternType, id: ID) =>
      generatePath(patternUpdateRoute, { type, id }),
  },
};
